import CarditList from '../../Cardit/List';
import './List.scss';

class List extends CarditList
{   
}

export default List;